import {FeatureToggle} from '../data';
import {FeatureMap, FeatureName, getEnabledFeatures} from '../infrastructure';
import {useAppSelector} from './useAppSelector';

export const useOverridableFeatureFlags = (overrides?: Map<FeatureName, boolean>) => {
  const enabledFeatures = new Set(useAppSelector(getEnabledFeatures));
  const features = Object.keys(FeatureToggle) as Array<FeatureName>;

  // Apply local overrides for debug and  testing purposes
  if (overrides) {
    for (const [name, enabled] of overrides) {
      if (enabled) {
        enabledFeatures.add(FeatureToggle[name]);
      } else {
        enabledFeatures.delete(FeatureToggle[name]);
      }
    }
  }

  const featureObject: FeatureMap = features.reduce(
    (prevFeature, featureName) => ({
      ...prevFeature,
      [featureName]: enabledFeatures.has(FeatureToggle[featureName]),
    }),
    {},
  );

  return featureObject;
};
